import { combineReducers } from '@reduxjs/toolkit';

import menu from "./menu";
import site from "./site";

const rootReducer = combineReducers( 
	{
		site: site,
		menu: menu
	}
);

export default rootReducer;